import { styled, css } from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  className?: string;
  type?: 'drawer' | 'modal' | 'nonModal' | undefined;
  $placement?: 'left' | 'right' | 'bottom' | 'top' | undefined;
  style?: React.CSSProperties;
  readonly onMouseDown?: any;
}

const getTopShowStyle = () => css`
  .modal-overlay {
    ${mixin.flex({ justify: 'flex-start', align: 'flex-start' })};
  }

  .modal-content {
    width: 100%;
    transform: translateY(-100%);
    animation-name: ${mixin.topHide};
    animation-duration: 0.3s;
    animation-fill-mode: forwards;
  }

  &.active {
    .modal-content {
      transform: translateY(0);
      animation-name: ${mixin.topShow};
    }
  }
`;

const getBottomShowStyle = () => css`
  .modal-overlay {
    ${mixin.flex({ justify: 'flex-end', align: 'flex-start' })};
  }

  .modal-content {
    width: 100%;
    transform: translateY(100%);
    animation-name: ${mixin.bottomHide};
    animation-duration: 0.3s;
    animation-fill-mode: forwards;
  }

  &.active {
    .modal-content {
      transform: translateY(0);
      animation-name: ${mixin.bottomShow};
    }
  }
`;

const getLeftShowStyle = () => css`
  .modal-overlay {
    ${mixin.flex({ justify: 'flex-start', align: 'flex-start' })};
  }

  .modal-content {
    height: 100vh;
    transform: translateX(100%);
    animation-name: ${mixin.leftHide};
    animation-duration: 0.3s;
    animation-fill-mode: forwards;
  }

  &.active {
    .modal-content {
      transform: translateX(0);
      animation-name: ${mixin.leftShow};
    }
  }
`;

const getRightShowStyle = () => css`
  .modal-overlay {
    ${mixin.flex({ justify: 'flex-start', align: 'flex-end' })};
  }

  .modal-content {
    height: 100vh;
    transform: translateX(100%);
    animation-name: ${mixin.rightHide};
    animation-duration: 0.3s;
    animation-fill-mode: backwards;
  }

  &.active {
    .modal-content {
      transform: translateX(0);
      animation-name: ${mixin.rightShow};
    }
  }
`;

export const Modal = styled.div<IProps>`
  ${props => {
    const placement = props.$placement;

    switch (placement) {
      case 'bottom':
        return css`
          ${getBottomShowStyle}
        `;
      case 'left':
        return css`
          ${getLeftShowStyle}
        `;
      case 'right':
        return css`
          ${getRightShowStyle}
        `;
      case 'top':
        return css`
          ${getTopShowStyle}
        `;
      default:
        return null;
    }
  }}

  ${props => {
    const $type = props.type;
    const $style = props.style;
    const $top = $style ? $style.top : 'auto';
    const $bottom = $style ? $style.bottom : '40px';
    const $left = $style ? $style.left : '40px';
    const $right = $style ? $style.right : 'auto';

    switch ($type) {
      case 'modal':
        return css`
          .modal-overlay {
            overflow: hidden scroll;
          }

          .modal-content {
            overflow: visible;
          }
        `;
      case 'nonModal':
        return css`
          .modal-overlay {
            background-color: transparent;
            top: ${$top || 'auto'};
            bottom: ${$bottom || '40px'};
            left: ${$left || '40px'};
            right: ${$right || 'auto'};
          }

          .modal-content {
            overflow: visible;
          }
        `;
      default:
        return null;
    }
  }}
`;

export const Layout = styled.div<IProps>`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.4);
  transition: transform 0.3s;
  ${mixin.flex({})}
  flex-direction: column !important;
`;

export const Box = styled.div`
  position: relative;
  word-break: break-all;
  transition: transform 0.3s;
  overflow: hidden; // drawer, bottom
  max-height: 100%;
  width: auto;
  height: auto;
  outline: none !important;
`;
